import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://learntotrade-production.up.railway.app/api/v1',
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
});

export default instance;
